import React from 'react';
import GxList from '../../gx/GxList';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import * as FxTable from '../../fx/FxTable';
import { isApp } from '../../gx/GxStore';
import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreClient } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxSnackbar from '../../cx/CxSnackbar';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';


const MxClientList = (props) => {
  const [{ trans }] = useTranslation();
  const size = useWindowSize();
  const [{ navTo }] = useNav();

  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);

  const r_list = React.useRef(null);
  let r_snack_error = React.useRef(null);

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    clearStore('StoreClient', storeClient);
    // eslint-disable-next-line
  }, []);

  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txBranchId') === '1') }; 
  const hasColumnContact = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txContact') === '1') };
  const hasColumnIc = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txIc') === '1') };
  const hasColumnCode = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txCode') === '1') };
  const hasColumnReference = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txReference') === '1') };
  const hasColumnCity = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txCity') === '1') };
  const hasColumnLang = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txLang') === '1') };
  const hasColumnRateCli = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txTypeRateCli') === '1') };
  const hasColumnFromCli = () => { return Boolean(localStorage.getItem('MxClientList.addcol_dtFromCli') === '1') };
  // OPCIONALES EN VETT/SPAW, OBLIGATORIO EN OTROS.
  const hasColumnEmail = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txEmail') === '1' || (!isApp('vett') && !isApp('spaw'))) };
  const hasColumnMobile = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txMobile') === '1' || (!isApp('vett') && !isApp('spaw'))) };
  const hasColumnPhone1 = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txPhone1') === '1' || (!isApp('vett') && !isApp('spaw'))) };
  const hasColumnPhone2 = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txPhone2') === '1' || (!isApp('vett') && !isApp('spaw'))) };
  // SÓLO EN VETT/SPAW
  const hasColumnFromAni = () => { return Boolean(localStorage.getItem('MxClientList.addcol_dtFromAni') === '1') };
  const hasColumnAnimalNumber = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txNumber') === '1') }; // VETT, SPAW
  const hasColumnAnimalChip = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txChip') === '1') }; // VETT, SPAW
  const hasColumnRateAni = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txTypeRateAni') === '1') }; // VETT, SPAW
  const hasColumnAnimalPassport = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txPassport') === '1') }; // VETT, SPAW
  const hasColumnAnimalAlert = () => { return Boolean(localStorage.getItem('MxClientList.addcol_txAlert') === '1') }; // VETT, SPAW

  const openForm = async (op, row) => {
    FxLog.infox('MxClientList.openForm', '...row', row);

    if (row === null) {
      storeClient.inClient = null;
      storeClient.txClient = null;
      setStoreClient(storeClient);
      navTo("client-form");

    } else {
      storeClient.inClient = row.original.inClient;
      storeClient.txClient = row.original.txClient;
      setStoreClient(storeClient);

      if ((isApp('vett') || isApp('spaw'))) {
        if (row.col_id==='txClient') {
          navTo("client-form");
        }
        if (row.col_id==='txAnimal') {
          storeClient.inAnimal = row.original.animal_inAnimal;
          storeClient.txAnimal = row.original.animal_txAnimal;
          FxLog.infox('MxClientList.openForm', '...storeClient.inAnimal:', storeClient.inAnimal);
          if (!storeClient.inAnimal) {
            storeClient.inAnimal = null;
            storeClient.txAnimal = null;
          }
          setStoreClient(storeClient);
          navTo("client-form");
          navTo("animal-form");
        }
      } else {
        navTo("client-form");
      }
  
    }

  }

  const getCursor = () => {
    if ((isApp('vett') || isApp('spaw'))) {
      return 'notallowed';
    } else {
      return '';
    }
  }

  const getTableColumns = () => {
    let cols = [];
    try {
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inClient", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: "txBranchId", Header: trans('field.branch_id'), accessor:"txBranchId", highlight: true, width: '5%', cursor: getCursor(), show: hasColumnBranchId() });
        cols.push({ id: "txClient", Header: trans('field.client'), accessor:"txClient", highlight: true, width: '30%' });
        cols.push({ id: "txContact", Header: trans('field.contact'), accessor:"txContact", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnContact() });
        cols.push({ id: "dtFromCli", Header: trans('field.from'), accessor: row => FxTable.cellToLocalDate(row["dtFrom"]), width: '6%', cursor: getCursor(), show: hasColumnFromCli() });
        cols.push({ id: "txRateCli", Header: trans('field.rate'), accessor: "txTypeRate", width: '10%', cursor: getCursor(), show: hasColumnRateCli() });
        cols.push({ id: "txIc", Header: trans('field.ic'), accessor:"txIc", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnIc() });
        cols.push({ id: "txCode", Header: trans('field.code'), accessor:"txCode", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnCode() });
        cols.push({ id: "txReference", Header: trans('field.reference'), accessor:"txReference", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnReference() });
        cols.push({ id: "txCity", Header: trans('field.city'), accessor:"txCity", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnCity() });
        cols.push({ id: "txEmail", Header: trans('field.email'), accessor:"txEmail", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnEmail() });
        cols.push({ id: "txMobile", Header: trans('field.mobile'), accessor:"txMobile", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnMobile() });
        cols.push({ id: "txPhone1", Header: trans('field.phone1'), accessor:"txPhone1", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnPhone1() });
        cols.push({ id: "txPhone2", Header: trans('field.phone2'), accessor:"txPhone2", highlight: true, width: '15%', cursor: getCursor(), show: hasColumnPhone2() });
        cols.push({ id: "txLang", Header: trans('field.language'), accessor: "txLang", width: '5%', cursor: getCursor(), show: hasColumnLang() });
        if ((isApp('vett') || isApp('spaw'))) {
          cols.push({ id: "inAnimal", Header: '_inAnimal', accessor: row => row["animal_inAnimal"], show: false });
          cols.push({ id: "txAnimal", Header: trans('field.patient'), accessor: "animal_txAnimal", 
            Cell: ({ value, row }) => r_list.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txAnimal"),
            width: '15%' });
          cols.push({ id: "dtFromAni", Header: trans('field.from'), accessor: row => FxTable.cellToLocalDate(row["animal_dtFrom"]), 
            width: '6%', cursor: getCursor(), show: hasColumnFromAni() });
          cols.push({ id: "txRateAni", Header: trans('field.rate'), accessor: "animal_txTypeRate", 
            width: '10%', cursor: getCursor(), show: hasColumnRateAni() });
          cols.push({ id: "txNumber", Header: trans('field.number'), accessor: "animal_txNumber", 
            Cell: ({ value, row }) => r_list.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txNumber"),
            width: '15%', cursor: getCursor(), show: hasColumnAnimalNumber() });
          cols.push({ id: "txChip", Header: trans('field.chip'), accessor: "animal_txChip", 
            Cell: ({ value, row }) => r_list.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txChip"),
            width: '15%', cursor: getCursor(), show: hasColumnAnimalChip() });
          cols.push({ id: "txPassport", Header: trans('field.passport'), accessor: "animal_txPassport", 
            Cell: ({ value, row }) => r_list.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txPassport"),
            width: '15%', cursor: getCursor(), show: hasColumnAnimalPassport() });
          cols.push({ id: id++, Header: trans('field.species'), accessor: "animal_txTypeAnimalSpecies", 
            Cell: ({ value, row }) => r_list.current.getTable().cellFormat(value, `${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`),
            width: '15%', cursor: getCursor() });
          cols.push({ id: "txBreed", Header: trans('field.breed'), accessor: "animal_txTypeAnimalBreed",
            Cell: ({ value, row }) => r_list.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txBreed"),
            width: '15%', cursor: getCursor() });
          cols.push({ id: "txAlert", Header: trans('field.alert'), accessor: "animal_txAlert", 
            width: '15%', cursor: getCursor(), show: hasColumnAnimalAlert() });
        } else {
        }
        cols.push({ id: id++, Header: trans('field.balance'), accessor: row => FxTable.cellTo2r00(row["theBalance"]), width: '10%', cursor: getCursor(), align: 'right' });

      } else { // PANTALLA PEQUEÑA
        cols.push({ id: "txClient", Header: trans('field.client'), accessor:"txClient", highlight: true, width: '70%' });
        if ((isApp('vett') || isApp('spaw'))) {
          cols.push({ id: "inAnimal", Header: '_inAnimal', accessor: row => row["animal_inAnimal"], show: false });
          cols.push({ id: "txAnimal", Header: trans('field.patient'), accessor: "animal_txAnimal", 
            Cell: ({ value, row }) => r_list.current.getTable().cellFormat(value, `ht|${FxDat.isExpired(row.original.animal_dtTo) ? 'colorA' : ''}`, "txAnimal"),
            width: '30%' });
        } else {
          cols.push({ id: "txMobile", Header: trans('field.mobile'), accessor: "txMobile", width: '30%' });
        }

      }
      cols.push({ id: "B", Header: "_cp_access", accessor: row => Boolean(row["inUser"]), show: false });
      cols.push({ id: "A", Header: "_inactive", accessor: row => FxDat.isExpired(row["dtTo"]), show: false });
      cols.push({ id: "R", Header: "_balance", accessor: row => Boolean((row["theBalance"]) < 0 ? true : false), show: false });
      cols.push({ id: 'P', Header: "_shopify", accessor: row => Boolean(row["boShopifyCli"] === '1'), show: false });

    } catch (error) {
      FxLog.errorx('MxClientList.getTableColumns', error)
    }
    return cols;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    cols.push({ id: 'txContact', name: trans('field.client') + '-' + trans('field.contact') + " +🔍︎", checked: hasColumnContact() ? '1' : '0' });
    cols.push({ id: 'dtFromCli', name: trans('field.client') + '-' + trans('field.from'), checked: hasColumnFromCli() ? '1' : '0' });
    cols.push({ id: 'txIc', name: trans('field.client') + '-' + trans('field.ic') + " +🔍︎", checked: hasColumnIc() ? '1' : '0' });
    cols.push({ id: 'txCode', name: trans('field.client') + '-' + trans('field.code') + " +🔍︎", checked: hasColumnCode() ? '1' : '0' });
    cols.push({ id: 'txReference', name: trans('field.client') + '-' + trans('field.reference') + " +🔍︎", checked: hasColumnReference() ? '1' : '0' });
    cols.push({ id: 'txTypeRateCli', name: trans('field.client') + '-' + trans('field.rate'), checked: hasColumnRateCli() ? '1' : '0' });
    cols.push({ id: 'txCity', name: trans('field.client') + '-' + trans('field.city') + " +🔍︎", checked: hasColumnCity() ? '1' : '0' });
    cols.push({ id: 'txLang', name: trans('field.client') + '-' + trans('field.language'), checked: hasColumnLang() ? '1' : '0' });
    if ((isApp('vett') || isApp('spaw'))) {
      cols.push({ id: 'txEmail', name: trans('field.client') + '-' + trans('field.email') + " +🔍︎", checked: hasColumnEmail() ? '1' : '0' });
      cols.push({ id: 'txMobile', name: trans('field.client') + '-' + trans('field.mobile') + " +🔍︎", checked: hasColumnMobile() ? '1' : '0' });
      cols.push({ id: 'txPhone1', name: trans('field.client') + '-' + trans('field.phone1') + " +🔍︎", checked: hasColumnPhone1() ? '1' : '0' });
      cols.push({ id: 'txPhone2', name: trans('field.client') + '-' + trans('field.phone2') + " +🔍︎", checked: hasColumnPhone2() ? '1' : '0' });
      // paciente
      cols.push({ id: 'dtFromAni', name: trans('field.patient') + '-' + trans('field.from'), checked: hasColumnFromAni() ? '1' : '0' });
      cols.push({ id: 'txNumber', name: trans('field.patient') + '-' + trans('field.number') + " +🔍︎", checked: hasColumnAnimalNumber() ? '1' : '0' });
      cols.push({ id: 'txChip', name: trans('field.patient') + '-' + trans('field.chip') + " +🔍︎", checked: hasColumnAnimalChip() ? '1' : '0' });
      cols.push({ id: 'txPassport', name: trans('field.patient') + '-' + trans('field.passport') + " +🔍︎", checked: hasColumnAnimalPassport() ? '1' : '0' });
      cols.push({ id: 'txTypeRateAni', name: trans('field.patient') + '-' + trans('field.rate'), checked: hasColumnRateAni() ? '1' : '0' });
      cols.push({ id: 'txAlert', name: trans('field.patient') + '-' + trans('field.alert'), checked: hasColumnAnimalAlert() ? '1' : '0' });
    } else {
    }
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxClientList.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txContact', options.includes('txContact') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_dtFromCli', options.includes('dtFromCli') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txIc', options.includes('txIc') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txCode', options.includes('txCode') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txReference', options.includes('txReference') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txCity', options.includes('txCity') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txLang', options.includes('txLang') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txTypeRateCli', options.includes('txTypeRateCli') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txEmail', options.includes('txEmail') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txMobile', options.includes('txMobile') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txPhone1', options.includes('txPhone1') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txPhone2', options.includes('txPhone2') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_dtFromAni', options.includes('dtFromAni') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txNumber', options.includes('txNumber') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txChip', options.includes('txChip') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txPassport', options.includes('txPassport') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txTypeRateAni', options.includes('txTypeRateAni') ? '1' : '0');
    localStorage.setItem('MxClientList.addcol_txAlert', options.includes('txAlert') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  const getTooltip = () => {
    let tip = '';
    if ((isApp('vett') || isApp('spaw'))) {
      if (size.isLarge) {
        tip = `${trans('field.client')}${' / ' + trans('field.patient')}${' / ' + trans('field.breed')}`;
      } else {
        tip = `${trans('field.client')}${' / ' + trans('field.patient')}`;
      }
      if (hasColumnAnimalNumber()) tip = tip + `${' / ' + trans('field.number')}`;
      if (hasColumnAnimalChip()) tip = tip + `${' / ' + trans('field.chip')}`;
      if (hasColumnAnimalPassport()) tip = tip + `${' / ' + trans('field.passport')}`;
    } else {
      tip = `${trans('field.client')}`;
    }
    if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
    if (hasColumnContact()) tip = tip + `${' / ' + trans('field.contact')}`;
    if (hasColumnIc()) tip = tip + `${' / ' + trans('field.ic')}`;
    if (hasColumnCode()) tip = tip + `${' / ' + trans('field.code')}`;
    if (hasColumnReference()) tip = tip + `${' / ' + trans('field.reference')}`;
    if (hasColumnCity()) tip = tip + `${' / ' + trans('field.city')}`;
    if (hasColumnEmail()) tip = tip + `${' / ' + trans('field.email')}`;
    if (hasColumnMobile()) tip = tip + `${' / ' + trans('field.mobile')}`;
    if (hasColumnPhone1()) tip = tip + `${' / ' + trans('field.phone1')}`;
    if (hasColumnPhone2()) tip = tip + `${' / ' + trans('field.phone2')}`;

    return tip;
  }

  return (
    <div>
      <GxList
        moduleName={trans('field.clients')}
        xref={r_list}
        id="MxClientList"
        tooltip={getTooltip()}
        fullscreen
        showtip
        //help="clients"
        url="clients"
        onOpenForm={openForm}
        refColors={[
          'table_cell_color_blue|' + trans('field.access_to_x', 'field.client_portal'),
          `table_cell_color_red|${trans('field.debtor')}`,
          `table_cell_color_gray|${trans('field.inactive')}`,
          'table_cell_color_pink|' + trans('field.shopify'),
        ]}
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        optionalSorting={[
          { id: 'txClient', type: trans('field.client') },
          { id: 'txCode', type: trans('field.code') },
          { id: 'txReference', type: trans('field.reference') },
        ]}
        onOptions={optionsSelected}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient theList={r_list} />
          </div>
        }
        speechExternal
      />
      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxClientList;
